<template>
  <AnalyticsWidget
    title="Invoice Breakdown"
    subTitle="New invoices created during the date ranges"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight">

    <LoadingPanel :loading="loading" />
    <AnalyticsBreakdownTable v-if="!loading">
      <template v-slot:header>
        <tr>
          <th></th>
          <th>Invoice Total</th>
          <th>Invoice Count</th>
        </tr>
      </template>
      <!-- TODO: Use inline popovers instead to show date ranges -->
      <template v-slot:body>
        <tr class="highlight">
          <td><Tooltip helpStyle label="Today's value compared to previous working day">Today</Tooltip></td>
          <AnalyticsBreakdownValueCell :value="invoiceBreakdownData.day.current.invoiceValue" :previous="invoiceBreakdownData.day.previous.invoiceValue" highlight>{{formatCurrency(invoiceBreakdownData.day.current.invoiceValue)}}</AnalyticsBreakdownValueCell>
          <AnalyticsBreakdownValueCell :value="invoiceBreakdownData.day.current.invoiceCount" :previous="invoiceBreakdownData.day.previous.invoiceCount">{{invoiceBreakdownData.day.current.invoiceCount}}</AnalyticsBreakdownValueCell>
        </tr>
        <tr>
          <td><Tooltip helpStyle label="This week compared to same day last week">This Week</Tooltip></td>
          <AnalyticsBreakdownValueCell :value="invoiceBreakdownData.week.current.invoiceValue" :previous="invoiceBreakdownData.week.previous.invoiceValue">{{formatCurrency(invoiceBreakdownData.week.current.invoiceValue)}}</AnalyticsBreakdownValueCell>
          <AnalyticsBreakdownValueCell :value="invoiceBreakdownData.week.current.invoiceCount" :previous="invoiceBreakdownData.week.previous.invoiceCount">{{invoiceBreakdownData.week.current.invoiceCount}}</AnalyticsBreakdownValueCell>
        </tr>
        <tr>
          <td><Tooltip helpStyle label="This month compared to same day last month">This Month</Tooltip></td>
          <AnalyticsBreakdownValueCell :value="invoiceBreakdownData.month.current.invoiceValue" :previous="invoiceBreakdownData.month.previous.invoiceValue">{{formatCurrency(invoiceBreakdownData.month.current.invoiceValue)}}</AnalyticsBreakdownValueCell>
          <AnalyticsBreakdownValueCell :value="invoiceBreakdownData.month.current.invoiceCount" :previous="invoiceBreakdownData.month.previous.invoiceCount">{{invoiceBreakdownData.month.current.invoiceCount}}</AnalyticsBreakdownValueCell>
        </tr>
        <tr>
          <td><Tooltip helpStyle label="This financial year compared to same day last financial year">This FY</Tooltip></td>
          <AnalyticsBreakdownValueCell :value="invoiceBreakdownData.financialYear.current.invoiceValue" :previous="invoiceBreakdownData.financialYear.previous.invoiceValue">{{formatCurrency(invoiceBreakdownData.financialYear.current.invoiceValue)}}</AnalyticsBreakdownValueCell>
          <AnalyticsBreakdownValueCell :value="invoiceBreakdownData.financialYear.current.invoiceCount" :previous="invoiceBreakdownData.financialYear.previous.invoiceCount">{{invoiceBreakdownData.financialYear.current.invoiceCount}}</AnalyticsBreakdownValueCell>
        </tr>
      </template>

    </AnalyticsBreakdownTable>
  </AnalyticsWidget>
</template>


<script>
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsBreakdownTable from '@/modules/intelligence/components/analyticsBreakdownTable'
import AnalyticsBreakdownValueCell from '@/modules/intelligence/components/analyticsBreakdownValueCell'

export default {
  name: 'InvoiceBreakdownWidget',
  components: {
    AnalyticsWidget,
    AnalyticsBreakdownTable,
    AnalyticsBreakdownValueCell
  },
  props: {
    filter: Object,
    contactId: Number,
    gridWidth: Number,
    gridHeight: Number
  },
  computed: {
    hasContactFilter() {
      return this.contactId != null
    }
  },
  data() {
    return {
      loading: true,
      invoiceBreakdownData: {}
    }
  },
  watch: {
    contactId: function() {
      this.requestData()
    },
    filter: function() {
      this.requestData()
    }
  },
  mounted() {
    this.loading = true
    this.requestData()

    this.subscribeEndpoint('/accounts/invoices', () => {
      this.requestData()
    })
  },
  beforeDestroy() {
    this.unsubscribeEndpoint('/accounts/invoices')
  },
  methods: {
    requestData() {
      var params = {
        contactId: this.contactId,
        accountLocationId: this.filter ? this.filter.accountLocationIdList : null,
      }

      this.$apiService.analyticsService.getInvoiceValueBreakdown(params)
      .then(response => {
        this.invoiceBreakdownData = response.data
      })
      .finally(() => {
        this.loading = false
      })
      .catch(err => {
      })
    }
  }
}
</script>